import React from 'react';
import * as BuilderUI from '../../../../components/Builder/BuilderUI';
import { assertCondition } from '../../../../utils/types';
import ReportFilter from '../../../../components/Builder/ReportFilter';
import {
  ExpressionModeKey,
  QueryType,
} from '../../../../utils/apollo/graphqlSchema';
import QueryMeasureHeading from './QueryMeasureHeading';
import QueryBuilderMeasures from './QueryBuilderMeasures';
import ImpactAnalysis from './ImpactAnalysis';
import Histogram from './Histogram';
import QueryBuilderBreakdown from './QueryBuilderBreakdown';
import QueryFormula from './QueryFormula';
import QueryBuilderHeader from './QueryBuilderHeader';
import QueryDateRangeSettings from './QueryDateRangeSettings';
import ExecuteReport from '../../../../components/Builder/ExecuteReport';
import useBuilderSelector from '../../../../redux/selectorHooks/useBuilderSelector';
import LlmPrompt from '../../../../components/Builder/LlmPrompt';
import useShowCloseLlmPrompt from '../../../../components/Builder/LlmPrompt/useShowCloseLlmPrompt';

const queryType = QueryType.Expression;

const QueryBuilder = () => {
  const selectedOptions = useBuilderSelector('selectedOptions');
  assertCondition(selectedOptions?.type === queryType);
  const expressionMode = selectedOptions.mode;

  const { showLlmPrompt, handleCloseLlmPrompt } = useShowCloseLlmPrompt();

  return (
    <>
      <QueryBuilderHeader />
      {showLlmPrompt && (
        <LlmPrompt
          queryType={QueryType.Expression}
          onClose={handleCloseLlmPrompt}
        />
      )}
      <BuilderUI.Part1>
        {expressionMode === ExpressionModeKey.Impact && <ImpactAnalysis />}
        <QueryMeasureHeading />
        <QueryBuilderMeasures />
        <QueryFormula />
      </BuilderUI.Part1>
      <BuilderUI.Part2>
        {expressionMode === ExpressionModeKey.Histogram && (
          <>
            <Histogram />
            <BuilderUI.HorizontalDivider />
          </>
        )}
        <ReportFilter />
        <BuilderUI.HorizontalDivider />
        <QueryBuilderBreakdown expressionMode={expressionMode} />
        <QueryDateRangeSettings />
      </BuilderUI.Part2>
      <ExecuteReport />
    </>
  );
};

export default QueryBuilder;
